module.exports = __webpack_public_path__ + "media/conversa/logo_sofia30_color-c22381fc.png";